var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ch-adult-btn"},[_c('ul',[_c('li',[_c('a',{ref:"confirm",staticClass:"round-btn-purple-f",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.confirm.apply(null, arguments)}}},[_vm._v("확인")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }